"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { useVirtualizedWaveMessages } from "./useVirtualizedWaveMessages";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import { NextPageProps } from "@/contexts/wave/hooks/useWavePagination";
import { DropSize } from "@/helpers/waves/drop.helpers";

/**
 * Hook that adapts the useVirtualizedWaveMessages hook to match the
 * interface expected by the WaveDropsAll component
 *
 * @param waveId - The ID of the wave to get messages for
 * @param dropId - The ID of the drop to get messages for
 * @param pageSize - Number of drops to load at a time (default: 50)
 */
export function useVirtualizedWaveDrops(waveId, dropId, t0) {
  const $ = _c(15);
  const pageSize = t0 === undefined ? 50 : t0;
  const {
    fetchNextPageForWave: originalFetchNextPage
  } = useMyStream();
  const virtualizedWaveMessages = useVirtualizedWaveMessages(waveId, dropId, pageSize);
  let t1;
  if ($[0] !== originalFetchNextPage || $[1] !== virtualizedWaveMessages || $[2] !== waveId) {
    t1 = async props => {
      if (waveId === props.waveId && virtualizedWaveMessages && props.type === DropSize.FULL) {
        if (virtualizedWaveMessages.hasMoreLocal) {
          virtualizedWaveMessages.loadMoreLocally();
          return Promise.resolve();
        }
      }
      return await originalFetchNextPage(props);
    };
    $[0] = originalFetchNextPage;
    $[1] = virtualizedWaveMessages;
    $[2] = waveId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const fetchNextPageForWave = t1;
  let t2;
  if ($[4] !== virtualizedWaveMessages) {
    t2 = async () => {
      if (virtualizedWaveMessages) {
        return virtualizedWaveMessages.fetchNextPageForDrop();
      }
    };
    $[4] = virtualizedWaveMessages;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const fetchNextpageForDrop = t2;
  let t3;
  if ($[6] !== fetchNextPageForWave || $[7] !== fetchNextpageForDrop) {
    t3 = async (props_0, dropId_0) => {
      if (dropId_0) {
        return await fetchNextpageForDrop();
      } else {
        return await fetchNextPageForWave(props_0);
      }
    };
    $[6] = fetchNextPageForWave;
    $[7] = fetchNextpageForDrop;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const fetchNextPage = t3;
  let t4;
  if ($[9] !== virtualizedWaveMessages) {
    t4 = async (serialNo, maxWaitTimeMs, pollIntervalMs) => {
      if (virtualizedWaveMessages) {
        return await virtualizedWaveMessages.waitAndRevealDrop(serialNo, maxWaitTimeMs, pollIntervalMs);
      }
    };
    $[9] = virtualizedWaveMessages;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const waitAndRevealDrop = t4;
  let t5;
  if ($[11] !== fetchNextPage || $[12] !== virtualizedWaveMessages || $[13] !== waitAndRevealDrop) {
    t5 = {
      waveMessages: virtualizedWaveMessages,
      fetchNextPage,
      waitAndRevealDrop
    };
    $[11] = fetchNextPage;
    $[12] = virtualizedWaveMessages;
    $[13] = waitAndRevealDrop;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}